import React from "react";
import MonitoringContainer from "./components/container";

export default function Index() {
    return <MonitoringContainer />;
}
